import request from '@/router/axios'
import env from '@/config/env'
import globalVariable from '@/config/globalVariable'

const { TIME } = globalVariable

/**
 * 根据供应商进行财务统计
 * @param customFinanceQueryParam
 */
export const selectCustomFinancePage = (customFinanceQueryParam) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/v2/statis-custom-page',
    method: 'GET',
    timeout: TIME,
    params: customFinanceQueryParam
  })
}
/**
 * 根据车辆定制客运财务统计
 * @param customFinanceQueryParam
 */
export const customFinanceByCar = (customFinanceQueryParam) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/v2/statis-custom-car-page',
    method: 'GET',
    timeout: TIME,
    params: customFinanceQueryParam
  })
}
/**
 * 根据线路定制客运财务统计
 * @param customFinanceQueryParam
 */
export const customFinanceByLine = (customFinanceQueryParam) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/v2/statis-custom-line-page',
    method: 'GET',
    timeout: TIME,
    params: customFinanceQueryParam
  })
}
/**
 * 根据班次定制客运财务统计
 * @param customFinanceQueryParam
 */
export const customFinanceByFlight = (customFinanceQueryParam) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/v2/statis-custom-flight-page',
    method: 'GET',
    timeout: TIME,
    params: customFinanceQueryParam
  })
}
/**
 * 摆渡服务费统计明细
 * @param customFinanceQueryParam
 */
export const statisFerryDetail = (customFinanceQueryParam) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/v2/statis-ferry-detail',
    method: 'GET',
    timeout: TIME,
    params: customFinanceQueryParam
  })
}
/**
 * 根据供应商查询线路
 */
export const getLineByMerchantIdList = (params) => {
  return request({
    url: env.ferryUrl + '/lineAdmin/getLineByMerchantIds',
    method: 'GET',
    timeout: TIME,
    params: params
  })
}
/**
 * 根据供应商查询车辆和司机信息
 */
export const getDriverAndCarInfo = (merchantIdList) => {
  return request({
    url: env.ferryUrl + '/merchant/car-driver-by-merchant',
    method: 'GET',
    timeout: TIME,
    params: merchantIdList
  })
}

/**
 * 供应商违约金数据明细分页
 */
export const merchantRefund = (params) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/merchant-refund',
    method: 'POST',
    data: params
  })
}
